export default "__VITE_ASSET__BLsQgwo9__"